import Vue from 'vue';
import config from '@/config/index';
export default {
    //列表页相关
    // 查询
    getDeaList(params) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/protocol/page`,
            method: 'get',
            params
        })
    },
    // 协议列表总
    getAllDealList(params) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/protocol/list`,
            method: 'get',
            params
        })
    },
    // 服务器分配相关
    // 获取服务器列表
    getServerList() {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/deviceServer/list`,
            method: 'get',
        })
    },
    // 增加OR修改
    addOrEditServer(data) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/protocolVersionServerRelevance/addServer`,
            method: 'post',
            data
        })
    },
    // 详情
    getServerDetail(params) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/protocolVersionServerRelevance/serverRelevance`,
            method: 'get',
            params
        })
    },
    // 负载量更改
    changeLoad(data) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/protocolVersionServerPort/updateServerLoad`,
            method: 'post',
            data
        })
    },
    // 优质服务器和端口
    getGoodServerAndPortByVersionId(params) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/protocolVersionServerRelevance/getSuitableServerAndPort`,
            method: 'get',
            params
        })
    },
    // 协议相关
    // 新增
    addDeal(data) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/protocol/add`,
            method: 'post',
            data
        })
    },
    // 修改
    editDeal(data) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/protocol/edit`,
            method: 'post',
            data
        })
    },
    // 详情
    getDealDetail(params) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/protocol/detail`,
            method: 'get',
            params
        })
    }
}